// removed by extract-text-webpack-plugin
module.exports = {"ba-modal":"magazines_2g4UV","ba-modal-card":"magazines_2NKpX","ba-relative":"magazines_3sxWn","ba-img":"magazines_2xOTe","ba-absolute":"magazines__MsZ0","ba-none":"magazines_VSpL9"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineEdit/styles.scss
// module id = 1037
// module chunks = 1